const KLAVIYO_URL = "https://a.klaviyo.com/client/events/?company_id=XXNC5g";
const LAST_REVISION = "2026-01-15";

const getFormData = (form: HTMLFormElement) => {
  const getValue = (name: string) =>
    (form.querySelector(`[name="contact[${name}]"]`) as HTMLInputElement)
      ?.value ?? "";

  return {
    recipientName: getValue("recipient_name"),
    recipientEmail: getValue("recipient_email"),
    senderName: getValue("name"),
    senderEmail: getValue("email"),
    productId: getValue("product_id"),
    productUrl: getValue("product_url"),
    message: getValue("message"),
  };
};

const buildKlaviyoPayload = (data: ReturnType<typeof getFormData>) => ({
  data: {
    type: "event",
    attributes: {
      metric: {
        data: {
          type: "metric",
          attributes: {
            name: "Drop a hint",
          },
        },
      },
      profile: {
        data: {
          type: "profile",
          attributes: {
            first_name: data.recipientName,
            email: data.recipientEmail,
          },
        },
      },
      properties: {
        from_name: data.senderName,
        from_email: data.senderEmail,
        subject: "Just between us\u2026",
        message:
          `Dear ${data.recipientName},\n\n` +
          `${data.senderName} has found something special.\n\n` +
          `It's the kind of piece that tends to stay on one's mind.\n\n` +
          `Should you wish to explore further, our team would be delighted to assist.\n\n` +
          `View ${data.senderName}'s selection: ${data.productUrl}\n\n` +
          `Paul Bram\nSince 1927`,
        product_id: data.productId,
        product_url: data.productUrl,
      },
    },
  },
});

const setStatus = (
  container: HTMLElement,
  type: "success" | "error",
  message: string,
) => {
  container.hidden = false;
  container.className = `drop-a-hint-status drop-a-hint-status--${type}`;
  container.textContent = message;
};

const handleSubmit = async (form: HTMLFormElement) => {
  const submitBtn = form.querySelector<HTMLButtonElement>(
    "[data-drop-a-hint-submit]",
  );
  const statusEl = form.querySelector<HTMLElement>("[data-drop-a-hint-status]");

  if (!submitBtn || !statusEl) return;

  statusEl.hidden = true;
  submitBtn.disabled = true;
  submitBtn.textContent = "Sending...";

  const data = getFormData(form);

  try {
    const response = await fetch(KLAVIYO_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: LAST_REVISION,
      },
      body: JSON.stringify(buildKlaviyoPayload(data)),
    });

    if (!response.ok) {
      throw new Error(`Request failed with status ${response.status}`);
    }

    setStatus(statusEl, "success", "Your hint has been sent!");
    form.reset();
  } catch {
    setStatus(statusEl, "error", "Something went wrong. Please try again.");
  } finally {
    submitBtn.disabled = false;
    submitBtn.textContent = "Send";
  }
};

const initDropAHint = () => {
  const closeBtns = document.querySelectorAll<HTMLElement>(
    "[data-drop-a-hint-close]",
  );
  const openBtns = document.querySelectorAll<HTMLElement>(
    "[data-drop-a-hint-open]",
  );

  const popup = document.getElementById("drop-a-hint");

  if (popup) {
    closeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        popup.classList.remove("is-fixed", "is-visible", "active");
      });
    });

    openBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        popup.classList.add("is-fixed", "is-visible", "active");
      });
    });
  }

  const form = document.getElementById(
    "DropAHintForm",
  ) as HTMLFormElement | null;

  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      handleSubmit(form);
    });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  initDropAHint();
});
